<template>
  <div class="main-layout">
    <StatisticNav />

    <div class="container mt-4">
      <child/>
    </div>
  </div>
</template>

<script>
import StatisticNav from '../components/statistic/StatisticNav'

export default {
  name: "StatisticLayout",

  components: {
    StatisticNav
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ../../../../resources/js/layouts/statistic.vue